import { NavBar } from '../components/landing/NavBar';
import { HeroSection } from '../components/landing/HeroSection';
import { CrisisSection } from '../components/landing/CrisisSection';
import { ScienceSection } from '../components/landing/ScienceSection';
import { PillarsSection } from '../components/landing/PillarsSection';
import { ScaffoldSection } from '../components/landing/ScaffoldSection';
import { ScoutSection } from '../components/landing/ScoutSection';
import { NeurotypeSection } from '../components/landing/NeurotypeSection';
import '../styles/neurotype-section.css';
import { MarketSection } from '../components/landing/MarketSection';
import { VisionSection } from '../components/landing/VisionSection';
import { AskSection } from '../components/landing/AskSection';
import { Footer } from '../components/landing/Footer';
import { BackToTopFab } from '../components/landing/BackToTopFab';

export function LandingPage() {
  return (
    <>
      <NavBar />
      <main>
        <HeroSection />
        <CrisisSection />
        <ScienceSection />
        <PillarsSection />
        <ScaffoldSection />
        <ScoutSection />
        <NeurotypeSection />
        <MarketSection />
        <VisionSection />
        <AskSection />
        <Footer />
      </main>
      <BackToTopFab />
    </>
  );
}
